interface FailedStateProps {
  feedback?: string;
  onResume?: () => void;
}

export default function FailedState({ feedback, onResume }: FailedStateProps) {
  return (
    <div className="text-center py-20">
      <h2 className="font-display text-2xl text-heading mb-3 [font-variation-settings:'opsz'_48,'SOFT'_60]">
        Your brief needs a bit more.
      </h2>
      {feedback && (
        <p className="text-muted-foreground text-base leading-relaxed max-w-md mx-auto mb-6">
          {feedback}
        </p>
      )}
      {onResume && (
        <button
          type="button"
          onClick={onResume}
          className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium text-sm py-3 px-6 rounded-button transition-opacity duration-80 hover:opacity-90"
        >
          Continue
          <span aria-hidden="true">&rarr;</span>
        </button>
      )}
    </div>
  );
}
